<template>
    <v-card class="transparent" flat>
        <v-layout>
            <nav-bar />
            <v-main  fluid app >
                <v-card class="transparent" flat :height="screensize.height - 60">
                    <slot />
                </v-card>
            </v-main>
        </v-layout>
    </v-card>
</template>

<script>
    import NavBar from '../components/Navbar.vue'
    export default {
        name: 'mainLayout',
        components: {
            NavBar,
        },
        data: () => ({
            screensize: {
                width: window.innerWidth,
                height: window.innerHeight,
            },
        }),
        mounted() {
            window.addEventListener('resize', this.onResize);
        },  
        methods: {
            onResize() {
                this.screensize.width = window.innerWidth;
                this.screensize.height = window.innerHeight;
            },
        },
    }

</script>

<style scoped>
    .transparent {
        background: transparent !important;
    }
</style>

